<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in">
  <div class="relative flex max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-800">
    <!-- Header -->
    <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700 sm:px-6 sm:py-4">
      <div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">{{ title }}</h3>
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Ajuste as bordas de recorte para selecionar a imagem inteira ou a parte desejada.
        </p>
      </div>
      <button
        type="button"
        (click)="onCancel()"
        class="text-gray-400 hover:text-gray-600 dark:hover:text-white transition p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
        aria-label="Fechar"
      >
        <ng-icon name="heroXMark" size="22px"></ng-icon>
      </button>
    </div>

    <!-- Toolbar: Controles de Proporção e Ferramentas -->
    <div class="flex flex-wrap items-center justify-between gap-2 border-b border-gray-100 bg-gray-50 px-4 py-2.5 dark:border-gray-700 dark:bg-gray-800/60 sm:px-6">
      <!-- Proporção -->
      <div class="flex items-center gap-1.5 text-xs">
        <span class="font-medium text-gray-500 dark:text-gray-400 mr-1 hidden sm:inline">Proporção:</span>
        <button
          type="button"
          (click)="setAspectMode('free')"
          [class.bg-brand-green-600]="aspectMode === 'free'"
          [class.text-white]="aspectMode === 'free'"
          [class.border-brand-green-600]="aspectMode === 'free'"
          [class.bg-white]="aspectMode !== 'free'"
          [class.text-gray-700]="aspectMode !== 'free'"
          class="rounded-md border border-gray-200 px-2.5 py-1 font-semibold transition hover:bg-brand-green-50 hover:text-brand-green-700 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
        >
          Livre (Logo Completa)
        </button>
        <button
          type="button"
          (click)="setAspectMode('1:1')"
          [class.bg-brand-green-600]="aspectMode === '1:1'"
          [class.text-white]="aspectMode === '1:1'"
          [class.border-brand-green-600]="aspectMode === '1:1'"
          [class.bg-white]="aspectMode !== '1:1'"
          [class.text-gray-700]="aspectMode !== '1:1'"
          class="rounded-md border border-gray-200 px-2.5 py-1 font-semibold transition hover:bg-brand-green-50 hover:text-brand-green-700 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
        >
          1:1 Quadrado
        </button>
        <button
          type="button"
          (click)="setAspectMode('16:9')"
          [class.bg-brand-green-600]="aspectMode === '16:9'"
          [class.text-white]="aspectMode === '16:9'"
          [class.border-brand-green-600]="aspectMode === '16:9'"
          [class.bg-white]="aspectMode !== '16:9'"
          [class.text-gray-700]="aspectMode !== '16:9'"
          class="rounded-md border border-gray-200 px-2.5 py-1 font-semibold transition hover:bg-brand-green-50 hover:text-brand-green-700 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
        >
          16:9 Banner
        </button>
      </div>

      <!-- Ações de Ajuste (Zoom, Rotação, Reset) -->
      <div class="flex items-center gap-1">
        <button
          type="button"
          (click)="rotateLeft()"
          class="rounded-lg border border-gray-200 bg-white p-1.5 text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
          title="Girar 90° para esquerda"
        >
          <ng-icon name="heroArrowUturnLeft" size="16px"></ng-icon>
        </button>
        <button
          type="button"
          (click)="rotateRight()"
          class="rounded-lg border border-gray-200 bg-white p-1.5 text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
          title="Girar 90° para direita"
        >
          <ng-icon name="heroArrowUturnRight" size="16px"></ng-icon>
        </button>
        <button
          type="button"
          (click)="zoomOut()"
          class="rounded-lg border border-gray-200 bg-white p-1.5 text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
          title="Diminuir zoom (-)"
        >
          <ng-icon name="heroMagnifyingGlassMinus" size="16px"></ng-icon>
        </button>
        <button
          type="button"
          (click)="zoomIn()"
          class="rounded-lg border border-gray-200 bg-white p-1.5 text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
          title="Aumentar zoom (+)"
        >
          <ng-icon name="heroMagnifyingGlassPlus" size="16px"></ng-icon>
        </button>
        <button
          type="button"
          (click)="resetAll()"
          class="rounded-lg border border-gray-200 bg-white p-1.5 text-gray-600 transition hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
          title="Redefinir recorte e zoom"
        >
          <ng-icon name="heroArrowPath" size="16px"></ng-icon>
        </button>
      </div>
    </div>

    <!-- Body / Cropper Area -->
    <div class="relative flex min-h-[300px] flex-1 flex-col items-center justify-center overflow-hidden bg-slate-900 p-4 sm:min-h-[400px] sm:p-6">
      <div *ngIf="loading" class="absolute inset-0 flex flex-col items-center justify-center bg-slate-900/90 z-20">
        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-green-500"></div>
        <p class="mt-3 text-sm text-gray-300">Preparando editor de imagem...</p>
      </div>

      <div class="w-full flex items-center justify-center flex-1 overflow-hidden">
        <image-cropper
          [imageFile]="imageFile"
          [maintainAspectRatio]="maintainAspectRatio"
          [aspectRatio]="aspectRatio"
          [containWithinAspectRatio]="containWithinAspectRatio"
          [allowMoveImage]="true"
          [onlyScaleDown]="true"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
          class="max-h-[55vh] w-full"
        ></image-cropper>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex flex-col-reverse gap-2 border-t border-gray-200 bg-white px-4 py-3 dark:border-gray-700 dark:bg-gray-800 sm:flex-row sm:items-center sm:justify-between sm:gap-3 sm:px-6 sm:py-4">
      <div class="text-xs text-gray-500 dark:text-gray-400">
        Dica: Arraste os pontos nos cantos para ajustar a área de corte sem cortar o logotipo.
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          (click)="onCancel()"
          class="w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 hover:text-gray-900 sm:w-auto"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="onConfirm()"
          class="w-full rounded-lg bg-brand-green-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-green-700 sm:w-auto shadow-sm"
        >
          Confirmar Recorte
        </button>
      </div>
    </div>
  </div>
</div>
